module.exports = require('./promise-delay-shim')
